import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/styles/Page.css";
import "../assets/styles/IncluirCreditoPage.css";
import { useNotificacao } from "../context/NotificacaoContext";
import { criarPreferencia } from "../services/PagamentoService";

export default function IncluirCredito() {
  const navigate = useNavigate();
  const [valor, setValor] = useState();
  const { mostrarNotificacao } = useNotificacao();

  const handleConfirmar = async (e) => {
    e.preventDefault();

    try {
      const res = await criarPreferencia({ valor });

      if (res.data?.url){
        window.location.href = res.data.url;
      } else {
        mostrarNotificacao("Não foi possível iniciar o checkout", "error");
      }
    } catch (error) {
      mostrarNotificacao("Erro ao iniciar o checkout", "error");
    }

    // const saldoAtual = parseFloat(localStorage.getItem("saldo") || "0");
    // const novoSaldo = saldoAtual + valor;

    // // Atualiza saldo
    // localStorage.setItem("saldo", novoSaldo);

    // // Atualiza histórico
    // const historico = JSON.parse(localStorage.getItem("historico") || "[]");
    // const novoRegistro = {
    //   valor,
    //   data: new Date().toLocaleDateString("pt-BR"),
    //   hora: new Date().toLocaleTimeString("pt-BR"),

    // };
    // localStorage.setItem("historico", JSON.stringify([novoRegistro, ...historico]));
    // localStorage.setItem("saldoAtualizado", "true");
    
    // mostrarNotificacao(`Crédito de R$ ${valor},00 adicionado com sucesso!`, "success");
    // setTimeout(() => navigate("/dashboard"), 2000);
  };

  return (
    <div className="page">
      <div className="page-box">
        <h2>Crédito</h2>
        <p>Selecione o valor para adicionar ao saldo:</p>
        <input
          type="number"
          step="0.01"
          value={valor}
          onChange={(e) => setValor(parseFloat(e.target.value))}
          placeholder="Digite o valor"
        />
        <div className="btn-options">
          <button className="btn-option" onClick={(e) => setValor(50)}>R$ 50,00</button>
          <button className="btn-option" onClick={(e) => setValor(100)}>R$ 100,00</button>
          <button className="btn-option" onClick={(e) => setValor(200)}>R$ 200,00</button>
        </div>
{/*         
        <select value={valor} onChange={(e) => setValor(parseFloat(e.target.value))}>
          <option value={50}>R$ 50,00</option>
          <option value={100}>R$ 100,00</option>
          <option value={200}>R$ 200,00</option>
        </select> */}
        <button onClick={handleConfirmar}>Confirmar Pagamento</button>
        <button className="btn-voltar" onClick={() => navigate("/dashboard")}>
          Cancelar
        </button>
      </div>  
    </div>
  );
}
